import { useEffect, useState } from "react";
import useMediaQueryHook from "@hooks/useMediaQueryHook";
import { useLocation, useNavigate } from "react-router-dom";
import ExampleImage from "@assets/images/detailExample.png";
import ExerciseDetailsHeader from "./ExerciseDetailsHeader";
import ImageWithFallback from "@components/ui/ImageFallback";
import { ReactComponent as Time } from "@assets/images/greenTime.svg";
import { ReactComponent as Dumble } from "@assets/images/dumble.svg";
import { ReactComponent as Loc } from "@assets/images/loc.svg";
import { ReactComponent as Dart } from "@assets/images/dart.svg";

const WeeklyExerciseDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { daySelected = "" } = location.state || {};
  const [selectedDay, setSelectedDay] = useState(daySelected);
  const sortedAvailableDays = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];
  const { isMobile } = useMediaQueryHook();
  useEffect(() => {
    if (!location.state) {
      navigate(-1);
    }
  }, [location.state, navigate]);
  if (location.state) {
    return (
      <>
        <ExerciseDetailsHeader />
        <div className="p-[18px] md:p-[36px]">
          {!isMobile ? (
            <div className="hidden md:flex bg-white rounded-full p-1 border border-[#E9E9E9] w-full gap-0 md:gap-2 my-3 shadow-md">
              {sortedAvailableDays?.map((day) => (
                <button
                  key={day}
                  className={`text-[14px] font-[400] font-[Lato] px-3 py-[11px] flex-1 ${
                    selectedDay === day
                      ? "text-white bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] rounded-[100px]"
                      : "text-black"
                  }`}
                  onClick={() => setSelectedDay(day)}
                >
                  {day}
                </button>
              ))}
            </div>
          ) : (
            <div className="flex md:space-x-2 pb-2 justify-end md:justify-center ">
              <select
                className="p-2 rounded-md text-[#0575E6] text-[14px]"
                value={selectedDay}
                onChange={(e) => setSelectedDay(e.target.value)}
              >
                {sortedAvailableDays?.map((day) => (
                  <option key={day} value={day}>
                    {day}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>

        <div className="flex flex-col-reverse gap-4 xl:grid xl:grid-cols-2 md:gap-8">
          <div className="space-y-4">
            {[1, 2].map((item, index) => (
              <div className="bg-white rounded-[16px] p-3 md:p-2 flex flex-col md:flex-row items-center">
                <ImageWithFallback
                  src={ExampleImage}
                  className="w-full md:w-[163px] h-[166px] object-cover rounded-[13px]"
                />
                <div className="w-full p-0 md:px-6 py-1 flex-1">
                  <p className="text-[14px] font-[Lato] font-[600] mb-2">
                    Full Body Cross-Fit Workout
                  </p>
                  <div className="flex flex-row lg:items-center gap-2 ">
                    <button className="text-[#4CA842]  text-[12px] bg-[#D7FFD2] rounded-full px-2 py-1 flex items-center gap-2 w-[fit-content] flex-1">
                      <p className="bg-white rounded-full w-7 h-7 flex items-center justify-center">
                        <Time />
                      </p>{" "}
                      Duration: 30 mins
                    </button>
                    <button className="text-[#E58B00]  text-[12px] bg-[#D2FCFF] rounded-full px-2 py-1 flex items-center gap-2 w-[fit-content] flex-1">
                      <p className="bg-white rounded-full w-7 h-7 flex items-center justify-center">
                        <Dumble />
                      </p>{" "}
                      Type: Strength{" "}
                    </button>
                  </div>
                  <div className="flex flex-row lg:items-center gap-2 my-2">
                    <button className="text-[#00B7FE]  text-[12px] bg-[#D2FCFF] rounded-full px-2 py-1 flex items-center gap-2 w-[fit-content] flex-1">
                      <p className="bg-white rounded-full w-7 h-7 flex items-center justify-center">
                        <Loc />
                      </p>{" "}
                      Location: Home
                    </button>
                    <button className="text-[#E50067] text-[12px] bg-[#FBDBEB] rounded-full px-2 py-1 flex items-center gap-2 w-[fit-content] flex-1">
                      <p className="bg-white rounded-full w-7 h-7 flex items-center justify-center">
                        <Dart />
                      </p>{" "}
                      Goal: Fat Burn
                    </button>
                  </div>
                  <button
                    className="w-full text-white bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] rounded-[4px] py-2 text-[12px] font-[500]"
                    onClick={() =>
                      navigate("/exercise-plan/view-plan", {
                        state: { daySelected: "Monday" },
                      })
                    }
                  >
                    View Plan
                  </button>
                </div>
              </div>
            ))}
          </div>
          <iframe
            className="w-full min-h-[300px] rounded-md shadow-lg"
            src="https://www.youtube.com/embed/wIynl3at0Rs"
            title="Exercise Video"
            allowFullScreen
          ></iframe>
        </div>
      </>
    );
  }
};

export default WeeklyExerciseDetails;
